import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/services/auth.service";
import { UnsubscribeOnDestroyAdapter } from "src/app/shared/UnsubscribeOnDestroyAdapter";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.sass']
})
export class ResetPasswordComponent extends UnsubscribeOnDestroyAdapter 
implements OnInit {
  authForm: UntypedFormGroup;
  submitted = false;loading = false; hide = true; chide = true;
  returnUrl: string;
  error = "";message = "";
  tokenParam: String = this.route.snapshot.queryParamMap.get("token");
  emailParam: String = this.route.snapshot.queryParamMap.get("email");
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {
    super();
  }
  ngOnInit() {
    this.authForm = this.formBuilder.group({
      password: ["", Validators.required],
      password_confirmation: ["", Validators.required],
    });
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
    
  }
  get f() {
    return this.authForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    if (this.authForm.invalid) {
      return;
    } else {
      this.subs.sink = this.authService
        .resetPassword(this.f.password.value, this.f.password_confirmation.value, this.tokenParam, this.emailParam)
        .subscribe(
          (res) => {
            if (res) {
              
              if (res.status == 200) {
                this.router.navigate(["/authentication/signin"]);
              } else {
                this.error = res.email;
              }
              this.submitted = false;
              this.loading = false;
            } else {
              this.error = "Something went wrong. Please try again or contact to info@erp.com";
            }
          },
          (error) => {
            this.error = error;
            this.submitted = false;
            this.loading = false;
          }
        );
    }
  }
}